export default "__VITE_ASSET__C7H52vhy__"